var bighouse = bighouse || {};

bighouse.formSubmissionEventTracking = (function () {

    function formSubmissionEvent(formName){
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': formName
        });
    }

    return {
        formSubmissionEvent: formSubmissionEvent
    };
})();